import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';

export type OrderResumeUi = {
  sellerName: string;
  orderDate: string;
  client: string;
  status: statusBadgeUi;
  deliversToAddress: string;
  paymentMethod: string;
  paymentIcon: string;
  subTotalProductCount: string;
  subTotalAmount: string;
  total: string;
};

export const initialState: OrderResumeUi = {
  sellerName: '',
  orderDate: '',
  client: '',
  status: {
    statusId: undefined,
    textColor: '',
    backgroundColor: '',
    edgeColor: '',
    text: '',
  },
  deliversToAddress: '',
  paymentMethod: '',
  paymentIcon: '',
  subTotalProductCount: '',
  subTotalAmount: '',
  total: '',
};
